import React from 'react';

// Main components
import CreateEvent from '../components/createEvent';
import ContractPage from '../components/ContractPage';
import GiftRegistryAddress from '../components/GiftRegistryAddress';
import GiftRegistryCelebrated from '../components/GiftRegistryCelebrated';
import { eventType } from '../../../utils/clientConstant';

// CoOwner components
import EventCoOwnerType1 from '../components/GiftRegistryCelebrated/components/EventCoOwnerType1';
import EventCoOwnerType2 from '../components/GiftRegistryCelebrated/components/EventCoOwnerType2';
import EventCoOwnerType3 from '../components/GiftRegistryCelebrated/components/EventCoOwnerType3';

// Utils
import commonUtil from '../../../utils/commonUtil';

// Main component consttants
const GiftRegistryCelebratedComponent = React.createFactory(GiftRegistryCelebrated); // 'GiftRegistryCelebrated'; //
const CreateEventComponent = React.createFactory(CreateEvent);
const GiftRegistryAddressComponent = React.createFactory(GiftRegistryAddress);
const ContractPageComponent = React.createFactory(ContractPage);

const applicationRoutes = commonUtil.getApplicationRoutes();
// Co-Owner components constants
// Wedding, Anniversary, Baby
const EventCoOwnerType1Component = React.createFactory(EventCoOwnerType1);
// Sweet_Fifteen, Other_Religious_Ceremonies, Bar_Mitzvah, Bat_Mitzvah, Baptism, Confirmation, First_Communion
const EventCoOwnerType2Component = React.createFactory(EventCoOwnerType2);
// Open House, {Reunion (Fiesta)}, Birthday (Cumpleanos), Despedida, Other
const EventCoOwnerType3Component = React.createFactory(EventCoOwnerType3);

export const strategy = {
  pageName: 'SelectMesaType',
  strategies: {
    Wedding: {
      url: applicationRoutes.createWedding,
      name: eventType.Boda,
      nameInEnglish: 'Wedding',
      eventType: 'Celebraciones',
      eventTypeUrl: applicationRoutes.celebrationType,
      coownerOptional: false,
      assignRole: true,
      components: [
        { step: eventType.Boda + '_1', component: GiftRegistryCelebratedComponent },
        { step: eventType.Boda + '_2', component: CreateEventComponent },
        { step: eventType.Boda + '_3', component: GiftRegistryAddressComponent },
        { step: eventType.Boda + '_4', component: ContractPageComponent },
      ],
      coOwnerComponent: EventCoOwnerType1Component,
      coOwnerDynamic: false,
      selectionEnable: true,
      permissionCheckBox: true,
      showTitle: true,
    },
    Baby: {
      url: applicationRoutes.createBaby,
      name: eventType.Bebe,
      nameInEnglish: 'Baby',
      eventType: 'Celebraciones',
      eventTypeUrl: applicationRoutes.celebrationType,
      coownerOptional: true,
      assignRole: true,
      components: [
        { step: eventType.Bebe + '_1', component: GiftRegistryCelebratedComponent },
        { step: eventType.Bebe + '_2', component: CreateEventComponent },
        { step: eventType.Bebe + '_3', component: GiftRegistryAddressComponent },
        { step: eventType.Bebe + '_4', component: ContractPageComponent },
      ],
      coOwnerComponent: EventCoOwnerType1Component,
      coOwnerDynamic: false,
      selectionEnable: true,
      permissionCheckBox: true,
      showTitle: true,
    },
    Sweet_Fifteen: {
      url: applicationRoutes.createXVYears,
      name: eventType.XV_Anos,
      nameInEnglish: 'Sweet_Fifteen',
      eventType: 'Celebraciones',
      eventTypeUrl: applicationRoutes.celebrationType,
      coownerOptional: false,
      assignRole: false,
      components: [
        { step: eventType.XV_Anos + '_1', component: GiftRegistryCelebratedComponent },
        { step: eventType.XV_Anos + '_2', component: CreateEventComponent },
        { step: eventType.XV_Anos + '_3', component: GiftRegistryAddressComponent },
        { step: eventType.XV_Anos + '_4', component: ContractPageComponent },
      ],
      coOwnerComponent: EventCoOwnerType1Component,
      coOwnerDynamic: false,
      selectionEnable: false,
      permissionCheckBox: true,
      showTitle: false,
    },
    First_Communion: {
      url: applicationRoutes.createFirst_communion,
      name: eventType.First_Communion,
      nameInEnglish: 'First_Communion',
      eventType: 'Celebraciones',
      eventTypeUrl: applicationRoutes.celebrationType,
      coownerOptional: false,
      assignRole: false,
      components: [
        { step: eventType.First_Communion + '_1', component: GiftRegistryCelebratedComponent },
        { step: eventType.First_Communion + '_2', component: CreateEventComponent },
        { step: eventType.First_Communion + '_3', component: GiftRegistryAddressComponent },
        { step: eventType.First_Communion + '_4', component: ContractPageComponent },
      ],
      coOwnerComponent: EventCoOwnerType1Component,
      coOwnerDynamic: false,
      selectionEnable: false,
      permissionCheckBox: false,
      showTitle: false,
    },
    Baptism: {
      url: applicationRoutes.createBaptisms,
      name: eventType.Baptism,
      nameInEnglish: 'Baptism',
      eventType: 'Celebraciones',
      eventTypeUrl: applicationRoutes.celebrationType,
      coownerOptional: false,
      assignRole: false,
      components: [
        { step: eventType.Baptism + '_1', component: GiftRegistryCelebratedComponent },
        { step: eventType.Baptism + '_2', component: CreateEventComponent },
        { step: eventType.Baptism + '_3', component: GiftRegistryAddressComponent },
        { step: eventType.Baptism + '_4', component: ContractPageComponent },
      ],
      coOwnerComponent: EventCoOwnerType1Component,
      coOwnerDynamic: false,
      selectionEnable: false,
      permissionCheckBox: false,
      showTitle: false,
    },
    Confirmation: {
      url: applicationRoutes.createConfirmations,
      name: eventType.Confirmacion,
      nameInEnglish: 'Confirmation',
      eventType: 'Celebraciones',
      eventTypeUrl: applicationRoutes.celebrationType,
      coownerOptional: false,
      assignRole: false,
      components: [
        { step: eventType.Confirmacion + '_1', component: GiftRegistryCelebratedComponent },
        { step: eventType.Confirmacion + '_2', component: CreateEventComponent },
        { step: eventType.Confirmacion + '_3', component: GiftRegistryAddressComponent },
        { step: eventType.Confirmacion + '_4', component: ContractPageComponent },
      ],
      coOwnerComponent: EventCoOwnerType1Component,
      coOwnerDynamic: false,
      selectionEnable: false,
      permissionCheckBox: false,
      showTitle: false,
    },
    Other_Religious_Ceremonies: {
      url: applicationRoutes.createReligious,
      name: eventType.Other_Religious_Ceremonies,
      nameInEnglish: 'Other_Religious_Ceremonies',
      eventType: 'Celebraciones',
      eventTypeUrl: applicationRoutes.celebrationType,
      assignRole: false,
      coownerOptional: false,
      components: [
        { step: eventType.Other_Religious_Ceremonies + '_1', component: GiftRegistryCelebratedComponent },
        { step: eventType.Other_Religious_Ceremonies + '_2', component: CreateEventComponent },
        { step: eventType.Other_Religious_Ceremonies + '_3', component: GiftRegistryAddressComponent },
        { step: eventType.Other_Religious_Ceremonies + '_4', component: ContractPageComponent },
      ],
      coOwnerComponent: EventCoOwnerType1Component,
      coOwnerDynamic: false,
      selectionEnable: false,
      permissionCheckBox: false,
      showTitle: false,
    },
    Bar_Mitzvah: {
      url: applicationRoutes.createBar_Mitzvah,
      name: eventType.Bar_Mitzvah,
      nameInEnglish: 'Bar_Mitzvah',
      eventType: 'Celebraciones',
      eventTypeUrl: applicationRoutes.celebrationType,
      coownerOptional: false,
      assignRole: false,
      components: [
        { step: eventType.Bar_Mitzvah + '_1', component: GiftRegistryCelebratedComponent },
        { step: eventType.Bar_Mitzvah + '_2', component: CreateEventComponent },
        { step: eventType.Bar_Mitzvah + '_3', component: GiftRegistryAddressComponent },
        { step: eventType.Bar_Mitzvah + '_4', component: ContractPageComponent },
      ],
      coOwnerComponent: EventCoOwnerType1Component,
      coOwnerDynamic: false,
      selectionEnable: false,
      permissionCheckBox: false,
      showTitle: false,
    },
    Bat_Mitzvah: {
      url: applicationRoutes.createBat_Mitzvah,
      name: eventType.Bat_Mitzvah,
      nameInEnglish: 'Bat_Mitzvah',
      eventType: 'Celebraciones',
      eventTypeUrl: applicationRoutes.celebrationType,
      coownerOptional: false,
      assignRole: false,
      components: [
        { step: eventType.Bat_Mitzvah + '_1', component: GiftRegistryCelebratedComponent },
        { step: eventType.Bat_Mitzvah + '_2', component: CreateEventComponent },
        { step: eventType.Bat_Mitzvah + '_3', component: GiftRegistryAddressComponent },
        { step: eventType.Bat_Mitzvah + '_4', component: ContractPageComponent },
      ],
      coOwnerComponent: EventCoOwnerType1Component,
      coOwnerDynamic: false,
      selectionEnable: false,
      permissionCheckBox: false,
      showTitle: false,
    },
    'Open House': {
      url: applicationRoutes.createOpenHouse,
      name: eventType.Open_House,
      eventType: 'Todo_tipo_de_eventos',
      eventTypeUrl: applicationRoutes.openType,
      assignRole: true,
      coownerOptional: true,
      components: [
        { step: eventType.Open_House + '_1', component: GiftRegistryCelebratedComponent },
        { step: eventType.Open_House + '_2', component: CreateEventComponent },
        { step: eventType.Open_House + '_3', component: GiftRegistryAddressComponent },
        { step: eventType.Open_House + '_4', component: ContractPageComponent },
      ],
      coOwnerComponent: EventCoOwnerType1Component,
      coOwnerDynamic: true,
      selectionEnable: true,
      permissionCheckBox: true,
      showTitle: true,
    },
    'Party/Meeting': {
      url: applicationRoutes.createMeetings,
      name: eventType.Fiesta_Reunion,
      eventType: 'Todo_tipo_de_eventos',
      eventTypeUrl: applicationRoutes.openType,
      assignRole: true,
      coownerOptional: true,
      components: [
        { step: eventType.Fiesta_Reunion + '_1', component: GiftRegistryCelebratedComponent },
        { step: eventType.Fiesta_Reunion + '_2', component: CreateEventComponent },
        { step: eventType.Fiesta_Reunion + '_3', component: GiftRegistryAddressComponent },
        { step: eventType.Fiesta_Reunion + '_4', component: ContractPageComponent },
      ],
      coOwnerComponent: EventCoOwnerType1Component,
      coOwnerDynamic: false,
      selectionEnable: true,
      permissionCheckBox: true,
      showTitle: true,
    },
    "Children's_Party": {
      url: applicationRoutes.createChildrensParty,
      name: eventType.Fiesta_Infantil,
      eventType: 'Todo_tipo_de_eventos',
      eventTypeUrl: applicationRoutes.openType,
      assignRole: true,
      coownerOptional: false,
      components: [
        { step: eventType.Fiesta_Infantil + '_1', component: GiftRegistryCelebratedComponent },
        { step: eventType.Fiesta_Infantil + '_2', component: CreateEventComponent },
        { step: eventType.Fiesta_Infantil + '_3', component: GiftRegistryAddressComponent },
        { step: eventType.Fiesta_Infantil + '_4', component: ContractPageComponent },
      ],
      coOwnerComponent: EventCoOwnerType1Component,
      coOwnerDynamic: false,
      selectionEnable: false,
      permissionCheckBox: true,
      showTitle: true,
    },
    Anniversary: {
      url: applicationRoutes.createAniversary,
      name: eventType.Aniversario,
      nameInEnglish: 'Anniversary',
      eventType: 'Todo_tipo_de_eventos',
      eventTypeUrl: applicationRoutes.openType,
      coownerOptional: false,
      assignRole: true,
      components: [
        { step: eventType.Aniversario + '_1', component: GiftRegistryCelebratedComponent },
        { step: eventType.Aniversario + '_2', component: CreateEventComponent },
        { step: eventType.Aniversario + '_3', component: GiftRegistryAddressComponent },
        { step: eventType.Aniversario + '_4', component: ContractPageComponent },
      ],
      coOwnerComponent: EventCoOwnerType1Component,
      coOwnerDynamic: false,
      selectionEnable: true,
      permissionCheckBox: true,
      showTitle: true,
    },
    Birthday: {
      url: applicationRoutes.createBirthday,
      name: eventType.Cumpleanos,
      eventType: 'Todo_tipo_de_eventos',
      eventTypeUrl: applicationRoutes.openType,
      assignRole: true,
      coownerOptional: true,
      components: [
        { step: eventType.Cumpleanos + '_1', component: GiftRegistryCelebratedComponent },
        { step: eventType.Cumpleanos + '_2', component: CreateEventComponent },
        { step: eventType.Cumpleanos + '_3', component: GiftRegistryAddressComponent },
        { step: eventType.Cumpleanos + '_4', component: ContractPageComponent },
      ],
      coOwnerComponent: EventCoOwnerType1Component,
      coOwnerDynamic: true,
      selectionEnable: true,
      permissionCheckBox: true,
      showTitle: true,
    },
    Farewell: {
      url: applicationRoutes.createFarewell,
      name: eventType.Despedida,
      eventType: 'Todo_tipo_de_eventos',
      eventTypeUrl: applicationRoutes.openType,
      assignRole: true,
      coownerOptional: true,
      components: [
        { step: eventType.Despedida + '_1', component: GiftRegistryCelebratedComponent },
        { step: eventType.Despedida + '_2', component: CreateEventComponent },
        { step: eventType.Despedida + '_3', component: GiftRegistryAddressComponent },
        { step: eventType.Despedida + '_4', component: ContractPageComponent },
      ],
      coOwnerComponent: EventCoOwnerType1Component,
      coOwnerDynamic: true,
      selectionEnable: true,
      permissionCheckBox: true,
      showTitle: true,
    },
    Others: {
      url: applicationRoutes.createOtras,
      name: eventType.Others,
      nameInEnglish: 'Others',
      eventType: 'Todo_tipo_de_eventos',
      eventTypeUrl: applicationRoutes.openType,
      assignRole: true,
      coownerOptional: true,
      components: [
        { step: eventType.Others + '_1', component: GiftRegistryCelebratedComponent },
        { step: eventType.Others + '_2', component: CreateEventComponent },
        { step: eventType.Others + '_3', component: GiftRegistryAddressComponent },
        { step: eventType.Others + '_4', component: ContractPageComponent },
      ],
      coOwnerComponent: EventCoOwnerType1Component,
      coOwnerDynamic: true,
      selectionEnable: true,
      permissionCheckBox: true,
      showTitle: true,
    },
    Mascotas: {
      url: applicationRoutes.createMascotas,
      name: eventType.Mascotas,
      nameInEnglish: 'Mascotas',
      eventType: 'Todo_tipo_de_eventos',
      eventTypeUrl: applicationRoutes.openType,
      assignRole: true,
      coownerOptional: true,
      components: [
        { step: eventType.Mascotas + '_1', component: GiftRegistryCelebratedComponent },
        { step: eventType.Mascotas + '_2', component: CreateEventComponent },
        { step: eventType.Mascotas + '_3', component: GiftRegistryAddressComponent },
        { step: eventType.Mascotas + '_4', component: ContractPageComponent },
      ],
      coOwnerComponent: EventCoOwnerType1Component,
      coOwnerDynamic: true,
      selectionEnable: true,
      permissionCheckBox: true,
      showTitle: true,
    },
  },
};
